import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "Page Not Found | TNT Coach AI",
    description: "The page you are looking for could not be found. Return to the TNT Coach AI homepage to explore AI-powered coaching.",
    noindex: true,
  });

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-midnight">
      {/* Background image */}
      <img
        src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/62e69b115b576beff55584f7bbab1e07.png"
        alt="Coach AI"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-midnight/80" />

      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50/10 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <img
          src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/62e69b115b576beff55584f7bbab1e07.png"
          alt="Coach AI"
          className="w-48 md:w-64 h-auto mb-8 rounded-lg shadow-2xl"
        />
        <h1 className="text-xl md:text-2xl font-semibold text-warm-white">This page has not been generated</h1>
        <p className="mt-2 text-base text-silver-grey font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-silver-grey">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white font-medium hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}